export default {
  number: 1,
  options: [
    {
      number: 1,
      button: {
        text: 'Andar 3 casas',
        solution: {
          visible: false,
          board: 2,
        }
      },
    },
    {
      number: 2,
      button: {
        text: 'Andar -3 casas',
        solution: {
          visible: false,
          board: 3,
        }
      },
    },
    {
      number: 3,
      button: {
        text: 'Girar 90º',
        solution: {
          visible: false,
          board: 4,
        },
      },
    },
  ]
}